import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> 27/05/2025</p>
      <p>This Privacy Policy explains how <strong>IMPACT</strong> ("we", "us", or "our") collects, uses, shares, and protects your personal data when you use our website at https://impactjournal.co.in.</p>

      <h2>1. Information We Collect</h2>
      <p>We collect various types of information to provide and improve our services:</p>
      <ul>
        <li><strong>Personal Information:</strong> Full name, email address, phone number, academic institution, designation, address, country.</li>
        <li><strong>Account Details:</strong> Username, encrypted password, login history.</li>
        <li><strong>Submission Data:</strong> Manuscript title, category, abstract, uploaded research files (PDF/DOC).</li>
        <li><strong>Payment Information:</strong> Transaction ID, payment confirmation (handled securely by payment gateways – we do NOT store credit/debit card numbers).</li>
        <li><strong>Device and Usage Data:</strong> IP address, browser type, device type, operating system, referring URLs, access times, and page views.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>Your data helps us:</p>
      <ul>
        <li>Register and manage your account</li>
        <li>Enable research submission and review workflow</li>
        <li>Process publication or registration payments</li>
        <li>Generate certificates and downloadable documents</li>
        <li>Send account, submission, and status-related notifications</li>
        <li>Respond to inquiries or support requests</li>
        <li>Improve website functionality and user experience</li>
        <li>Maintain compliance with legal obligations</li>
      </ul>

      <h2>3. Sharing and Disclosure</h2>
      <p>We do not sell your personal data. Your data may be shared only:</p>
      <ul>
        <li>With internal editorial/reviewer teams for processing submissions</li>
        <li>With secure third-party payment providers (e.g., Razorpay, Paytm)</li>
        <li>With email delivery services (e.g., SendGrid, Mailchimp)</li>
        <li>With legal authorities if required under law</li>
      </ul>

      <h2>4. Cookies and Tracking</h2>
      <p>We use cookies and similar technologies to:</p>
      <ul>
        <li>Keep you logged in</li>
        <li>Remember preferences</li>
        <li>Measure traffic and performance via analytics tools (e.g., Google Analytics)</li>
      </ul>
      <p>You may disable cookies via your browser settings, but some features may not function properly.</p>

      <h2>5. Data Security</h2>
      <p>We implement robust security measures:</p>
      <ul>
        <li>HTTPS encryption across the platform</li>
        <li>Server-side protection and firewalling</li>
        <li>Password encryption (bcrypt or similar hashing)</li>
        <li>Access restrictions and secure storage of sensitive data</li>
      </ul>
      <p>However, no method is 100% secure. We encourage you to use strong passwords and log out after use.</p>

      <h2>6. Data Retention</h2>
      <ul>
        <li>User accounts: Stored until the user requests deletion</li>
        <li>Submissions: Retained for academic and archive purposes</li>
        <li>Payment data: Retained for 7 years as required by law</li>
      </ul>

      <h2>7. Your Rights</h2>
      <p>You may contact us to:</p>
      <ul>
        <li>Request access to your data</li>
        <li>Update or correct inaccurate information</li>
        <li>Delete your account and related data</li>
        <li>Unsubscribe from newsletters and non-essential emails</li>
      </ul>
      <p>Email: <strong>privacy@impactjournal.co.in</strong></p>

      <h2>8. Children's Privacy</h2>
      <p>We do not knowingly collect data from children under the age of 18. If found, we will delete the data immediately.</p>

      <h2>9. Third-Party Links</h2>
      <p>Our website may contain links to other websites. We are not responsible for their privacy policies or practices.</p>

      <h2>10. Changes to This Policy</h2>
      <p>This policy may be updated from time to time. Major changes will be notified via email or on this page.</p>

      <h2>11. Contact Us</h2>
      <p>For any questions regarding this Privacy Policy, contact us at:</p>
      <p><strong>Email:</strong> privacy@impactjournal.co.in</p>
      <p><strong>Website:</strong> https://impactjournal.co.in</p>
    </div>
  );
};

export default PrivacyPolicy;
